import React, { lazy } from 'react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="pb-6 md:pb-10 bg-cream relative overflow-hidden" data-id="element-29">
      {/* Product title */}
      <div className="text-center py-8 md:py-12 px-4 animate-fade-in-up" data-id="element-30">
        <h2 className="text-4xl md:text-6xl font-serif font-bold text-charcoal tracking-tight mb-3" data-id="element-31">
          CADENAS ROTAS
        </h2>
        <div className="w-16 h-0.5 bg-gold mx-auto mb-4" data-id="element-32"></div>
        <p className="text-sm md:text-base text-charcoal-light max-w-xl mx-auto leading-relaxed italic font-serif" data-id="element-33">
          El Manual para Sanar las Ataduras de tu Historia y Reclamar tu
          Bendición Familiar
        </p>
      </div>

      {/* Hero image */}
      <div className="mb-12 md:mb-16 flex justify-center px-4 animate-fade-in delay-100" data-id="element-34">
        <img src="https://cdn.magicpatterns.com/uploads/6pT8v4smEDssSgnRZYLMdi/mockup_hero.png" alt="Cadenas Rotas - Manual de sanación espiritual" className="w-64 md:w-80 h-auto object-cover rounded-sm shadow-md" decoding="async" data-id="element-35" />
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20" data-id="element-36">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full border border-gold/40" data-id="element-37"></div>
        <div className="absolute top-20 -left-20 w-64 h-64 rounded-full border border-gold/30" data-id="element-38"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10 px-4" data-id="element-39">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif text-charcoal font-bold leading-tight mb-6 animate-fade-in-up delay-100" data-id="element-40">
          ¿Y si el motivo por el que no puedes avanzar{' '}
          <span className="text-gold-dark italic" data-id="element-41">no es tuyo...</span> sino de
          alguien que vivió antes de que nacieras?
        </h1>

        {/* Decorative sparkle divider */}
        <div className="flex items-center justify-center gap-3 mb-10 animate-fade-in delay-150" data-id="element-42">
          <div className="h-px w-16 bg-gold/40" data-id="element-43"></div>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="text-gold" data-id="element-44">
            <path d="M10 0L10.9 7.5L18 10L10.9 12.5L10 20L9.1 12.5L2 10L9.1 7.5L10 0Z" fill="currentColor" opacity="0.6" data-id="element-45" />
          </svg>
          <div className="h-px w-16 bg-gold/40" data-id="element-46"></div>
        </div>

        <h2 className="text-lg md:text-xl text-charcoal-light mb-10 mx-auto leading-relaxed animate-fade-in-up delay-200" data-id="element-47">
          Descubre el método de 7 días para identificar y cortar las ataduras
          invisibles que frenan tu abundancia, tus relaciones y tu paz interior.
        </h2>

        {/* 3D Book image */}
        <div className="mb-10 animate-scale-in delay-200" data-id="element-48">
          <img src="https://cdn.magicpatterns.com/uploads/cCJY9PoULZBtJiYKEjV76U/Libro_3d.png" alt="Cadenas Rotas - Libro" className="w-64 md:w-80 mx-auto" decoding="async" data-id="element-49" />
        </div>

        {/* Pulsing CTA Button */}
        <div className="mb-12 animate-fade-in-up delay-250" data-id="element-50">
          <CTAButton pulse data-id="element-51" />
          <p className="mt-4 text-sm text-charcoal-light flex items-center justify-center gap-2" data-id="element-52">
            <span className="inline-block w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-53"></span>
            Acceso inmediato. Descarga digital.
          </p>
        </div>

        <div className="bg-white p-6 md:p-8 rounded-sm shadow-sm border border-gold/20 mb-12 text-center max-w-3xl mx-auto animate-fade-in-up delay-300" data-id="element-54">
          <p className="text-charcoal mb-4 leading-relaxed" data-id="element-55">
            <strong className="font-serif text-xl" data-id="element-56">
              Oras. Trabajas. Decretas.
            </strong>{' '}
            Y aun así... sientes que hay algo que no te deja despegar del todo.
            No es falta de fe. No es falta de esfuerzo. Es algo más profundo,
            más antiguo y más silencioso que tú.
          </p>
          <p className="text-charcoal leading-relaxed" data-id="element-57">
            Seguro lo has sentido: esa sensación de llegar casi al éxito para
            que algo lo arruine. No es coincidencia.{' '}
            <span className="font-semibold text-gold-dark" data-id="element-58">
              Es una herencia espiritual que estás cargando sin saberlo.
            </span>
          </p>
        </div>

        {/* Product mockup image */}
        <div className="mt-4" data-id="element-59">
          <img src="https://cdn.magicpatterns.com/uploads/bdBPw1asfiVN3WXyHKVRd1/mockup1.png" alt="Cadenas Rotas - Disponible en todos tus dispositivos" className="w-48 md:w-72 mx-auto" loading="lazy" decoding="async" data-id="element-60" />
        </div>
      </div>
    </section>;
}